import { render } from "./TestChallengeBlock.vue?vue&type=template&id=8f80d744&scoped=true"
import script from "./TestChallengeBlock.vue?vue&type=script&lang=js"
export * from "./TestChallengeBlock.vue?vue&type=script&lang=js"

import "./TestChallengeBlock.vue?vue&type=style&index=0&id=8f80d744&lang=stylus&scoped=true"
script.render = render
script.__scopeId = "data-v-8f80d744"

export default script